import SlimSelect from 'slim-select'

export default class SlimSelectController {
    constructor() {

        if (!document.querySelector(".slim-select")) {
            return;
        }

        this.slimSelect = new SlimSelect({
            select: '.slim-select',
            showSearch: false
        });
    }
}

